import { ApiClient } from "@eventsquare/uikit";
import { EnvironmentType } from "@eventsquare/uikit/dist/helpers/Environment";

export const Api = ApiClient.create({
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT as EnvironmentType,
  apiKey: process.env.NEXT_PUBLIC_API_KEY as string,
});
